import { getToken } from '../Context/User.context';
import API from './index';

export const getMissions = () => API.get('/mission', {headers: { "Authorization": `Bearer ${getToken()}`}});
